/**
 * Упрощенный Quick Add Button
 * Работает с нативным cart-form-handler.js через событие cart:updated
 */
(function() {
  'use strict';

  class QuickAddButton {
    constructor(el) {
      this.el = el;
      this.wrapper = el.closest('.quick-add-button-wrapper');
      this.variantId = this.wrapper?.dataset.variantId;
      this.form = this.wrapper?.querySelector('[data-product-form]');

      this.circle = el.querySelector('[data-quick-add-circle]');
      this.counter = el.querySelector('[data-quick-add-counter]');
      this.num = el.querySelector('[data-quick-add-count]');
      this.minus = el.querySelector('[data-quick-add-minus]');
      this.plus = el.querySelector('[data-quick-add-plus]');

      this.count = 0;
      this.processing = false;

      this.init();
    }

    init() {
      if (!this.variantId) return;

      // Синхронизируем счетчик при инициализации
      this.sync();

      // Обработчик для кнопок +/-
      this.plus?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.processing) return;
        this.changeQuantity(1);
      });

      this.minus?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.processing || this.count <= 0) return;
        this.changeQuantity(-1);
      });

      // Слушаем событие обновления корзины
      document.addEventListener('cart:updated', (event) => {
        this.sync(event.detail.cart);
      });
    }

    /**
     * Изменяет количество товара в корзине
     */
    async changeQuantity(delta) {
      if (this.processing) return;
      this.processing = true;

      const currentCount = this.count;
      const newCount = Math.max(0, currentCount + delta);

      // Блокируем кнопки
      if (this.plus) this.plus.disabled = true;
      if (this.minus) this.minus.disabled = true;
      this.el.classList.add('is-loading');

      try {
        if (newCount === 0) {
          // Удаляем товар из корзины
          const cart = await fetch('/cart.js').then(r => r.json());
          const item = cart.items.find(i => i.variant_id == this.variantId);
          if (item) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
          }
        } else if (currentCount === 0) {
          // Добавляем товар в корзину
          const formData = new FormData();
          formData.append('id', this.variantId);
          formData.append('quantity', String(newCount));
          await fetch('/cart/add.js', { method: 'POST', body: formData });
        } else {
          // Изменяем количество
          const cart = await fetch('/cart.js').then(r => r.json());
          const item = cart.items.find(i => i.variant_id == this.variantId);
          if (item) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: newCount })
            });
          }
        }

        const updatedCart = await fetch('/cart.js').then(r => r.json());
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: updatedCart,
            item_count: updatedCart.item_count || 0,
            items: updatedCart.items || []
          }
        }));

        if (currentCount === 0 && newCount > 0 && window.showProductAddNotification) {
          const addedItem = updatedCart.items?.find((entry) => String(entry.variant_id) === String(this.variantId));
          if (addedItem) {
            window.showProductAddNotification(addedItem, null, updatedCart);
          }
        }

      } catch (error) {
        console.error('Failed to update cart:', error);
      } finally {
        this.processing = false;
        if (this.plus) this.plus.disabled = false;
        if (this.minus) this.minus.disabled = false;
        this.el.classList.remove('is-loading');
      }
    }

    /**
     * Синхронизирует счетчик с корзиной
     */
    sync(cart = null) {
      if (this.processing) return;

      // Если корзина не передана, загружаем её
      if (!cart) {
        fetch('/cart.js')
          .then(r => r.json())
          .then(cartData => this.updateCount(cartData))
          .catch(() => {});
        return;
      }

      this.updateCount(cart);
    }

    /**
     * Обновляет счетчик на основе данных корзины
     */
    updateCount(cart) {
      if (!cart || !cart.items) return;

      const item = cart.items.find(i => i.variant_id == this.variantId);
      const newCount = item ? item.quantity : 0;

      if (this.count !== newCount) {
        this.count = newCount;
        this.updateUI();
      }
    }

    /**
     * Обновляет UI кнопки
     */
    updateUI() {
      if (this.num) this.num.textContent = this.count;
      if (this.el) {
        this.el.classList.toggle('is-expanded', this.count > 0);
      }
      if (this.counter) {
        this.counter.classList.toggle('is-visible', this.count > 0);
      }
    }
  }

  /**
   * Инициализация всех Quick Add кнопок
   */
  function initButtons() {
    const buttons = document.querySelectorAll('[data-quick-add-button]');
    buttons.forEach(button => {
      if (!button._qa) {
        button._qa = new QuickAddButton(button);
      }
    });
  }

  /**
   * Инициализация при загрузке
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtons);
  } else {
    initButtons();
  }

  // Инициализация при динамической загрузке секций
  document.addEventListener('shopify:section:load', initButtons);
  document.addEventListener('filter:update', initButtons);

  // MutationObserver для динамически добавленных карточек
  const observer = new MutationObserver((mutations) => {
    let shouldInit = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches && node.matches('[data-quick-add-button]')) {
            shouldInit = true;
          } else if (node.querySelector && node.querySelector('[data-quick-add-button]')) {
            shouldInit = true;
          }
        }
      });
    });
    if (shouldInit) {
      initButtons();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

